import React, { useState } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input
} from "reactstrap";
import {
    checkLogin,
    setUserAccessToken,
    changeWorkspace,
    errorNotification,
    successNotification,
    loginErrorFlag,
} from "../../store/actions";
import axios from "axios";
import { API_URL_CONSENT_APPROVEMENT } from "../../common/constants";

const ConsentModal = (props) => {
    const { 
        t,
        lng,
        modalData,
        toggleModal,
        consentAccepted
    } = props;

    const [ consent, setConsent ] = useState(false);

    const toggleConsent = () => setConsent(!consent);

    const handleSubmit = async () => {
        const url = API_URL_CONSENT_APPROVEMENT;
        const data = {
            privacyPolicyAccepted: consent,
            userPolicyAccepted: consent
        }
        
        try {
            const response = await axios.post(url, data, {
                headers: {
                    Authorization: `Bearer ${ modalData.token }`,
                },
            });
        
            if (response.status === 200) {
                consentAccepted();
            } else {
                props.errorNotification({message: "Failed to submit data."})
            }
        } catch {
            props.errorNotification({message: "Failed to submit data."})
        }
        
    }

    return (
        <Modal isOpen={modalData ? true : false} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>
                {t("Your Privacy and Consent")}
            </ModalHeader>

            <ModalBody>
                <Input 
                    type="checkbox" 
                    checked={consent} 
                    onChange={toggleConsent} 
                    className="me-2" 
                />
                { lng === "de" ? 
                    <>
                        {`Ich stimme den `}
                        <a 
                            href='user_policy' 
                            target="_blank"
                            rel='noreferrer'
                        >
                            Nutzungsbedingungen
                        </a> 
                        {` und der `}
                        <a 
                            href='data_privacy'
                            target="_blank"
                            rel='noreferrer'
                        >Datenschutzerklärung</a>
                        {` zu. `}
                    </>
                : 
                    <>
                        {`${t('I agree to')} `}
                        <a 
                            href='user_policy' 
                            target="_blank"
                            rel='noreferrer'
                        >
                            {t("User policy")}
                        </a> 
                        {` ${t("and")} `}
                        <a 
                            href='data_privacy' 
                            target="_blank"
                            rel='noreferrer'
                        >
                            {t("Data privacy")}
                        </a>
                    </>
                }
            </ModalBody>

            <ModalFooter>
                <Button 
                    color="primary" 
                    onClick={handleSubmit} 
                    disabled={!consent}
                    className="me-2"
                >
                    {t("Submit")}
                </Button>
                <Button 
                    color="secondary" 
                    onClick={toggleModal}
                >
                    {t("Cancel")}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

const mapStatetoProps = (state) => {
    const { Feature } = state;
    return {
        Feature,
        user: state.Login.user,
        token: state.Login.token,
        organization: state.Organization,
        loginErrFlag: state.Login.loginErrFlag,
    };
};

export default withNamespaces()(
    withRouter(
        connect(mapStatetoProps, {
            checkLogin,
            setUserAccessToken,
            loginErrorFlag,
            changeWorkspace,
            errorNotification,
            successNotification,
        })(ConsentModal)
    )
);
